import { useTheme } from '@shopify/restyle';
import { Column } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { Trans } from 'react-i18next';
import type { Theme } from 'app/shopify';
import type { InvitedUsers } from './shared';
import { ReferralCardTitle } from './referral-card-title';
import { ReferralProgress } from './referral-progress';

export function ReferralCard({
  invitedUsers,
  isReferralProgram,
  isReferralProgram202506,
  numInvited,
  tPrefix,
}: {
  invitedUsers: InvitedUsers;
  isReferralProgram: boolean;
  isReferralProgram202506: boolean;
  numInvited: number;
  tPrefix: string;
}) {
  const theme = useTheme<Theme>();
  return (
    <Column
      alignItems="center"
      gap="spacing.general.x6"
      style={{
        borderColor: theme.colors['surface.tertiary'],
        borderRadius: theme.borderRadii['radius.xl'],
        borderWidth: 1,
        padding: theme.spacing['spacing.general.x4'],
      }}
    >
      <ReferralCardTitle isReferralProgram202506={isReferralProgram202506} numInvited={numInvited} tPrefix={tPrefix} />
      <ReferralProgress
        invitedUsers={invitedUsers}
        isReferralProgram={isReferralProgram}
        isReferralProgram202506={isReferralProgram202506}
        numInvited={numInvited}
        tPrefix={tPrefix}
      />
      {isReferralProgram202506 ? (
        <Text style={{ marginTop: -theme.spacing['spacing.general.x4'] }}>
          <Trans
            components={{ strong: <Text fontWeight="700" /> }}
            i18nKey={`${tPrefix}currentStep.progress`}
            ns="invite"
            values={{ numInvites: numInvited }}
          />
        </Text>
      ) : null}
    </Column>
  );
}
